export default __webpack_public_path__ + "static/star-127e347ad5c1994bfc9e0ed848b7e636.svg";